import * as z from "zod/v4";

export const disconnectPayPalIntegration = {
  name: "disconnectPayPalIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
